module.exports = __webpack_public_path__ + "static/media/payslipForYourEmployees.adbd34c1.svg";